import { Encoder, Utils } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { MoveCoord } from '../../jscaip/MoveCoord';
import { Ordinal } from '../../jscaip/Ordinal';
import { EpaminondasFailure } from './EpaminondasFailure';
export class EpaminondasMove extends MoveCoord {
    phalanxSize;
    stepSize;
    direction;
    static encoder = Encoder.tuple([Coord.encoder, Encoder.identity(), Encoder.identity(), Ordinal.encoder], (m) => [m.coord, m.phalanxSize, m.stepSize, m.direction], (fields) => new EpaminondasMove(fields[0].x, fields[0].y, fields[1], fields[2], fields[3]));
    constructor(x, y, phalanxSize, stepSize, direction) {
        super(x, y);
        this.phalanxSize = phalanxSize;
        this.stepSize = stepSize;
        this.direction = direction;
        Utils.assert(phalanxSize > 0, 'Must select minimum one piece (got ' + phalanxSize + ').');
        Utils.assert(stepSize > 0, 'Step size must be minimum one (got ' + stepSize + ').');
        Utils.assert(stepSize <= phalanxSize, EpaminondasFailure.PHALANX_CANNOT_JUMP_FURTHER_THAN_ITS_SIZE(stepSize, phalanxSize));
    }
    toString() {
        return 'EpaminondasMove(' + this.coord.toString() + ', m:' +
            this.phalanxSize + ', s:' +
            this.stepSize + ', ' +
            this.direction.toString() + ')';
    }
    equals(other) {
        if (this === other)
            return true;
        if (this.coord.equals(other.coord) === false)
            return false;
        if (this.phalanxSize !== other.phalanxSize)
            return false;
        if (this.stepSize !== other.stepSize)
            return false;
        return this.direction.equals(other.direction);
    }
}
